import { CommonModule } from '@angular/common';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

import { TextEditorComponent } from './text-editor.component';
import { RnplCommonModule } from 'common/src/modules';
import { AddFontButtonModule } from '../add-font-button/add-font-button.module';


@NgModule({
  declarations: [
    TextEditorComponent
  ],
  exports: [
    TextEditorComponent
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    FormsModule,
    RnplCommonModule,
    TranslateModule,
    NgSelectModule,
    ColorPickerModule,
    AddFontButtonModule,
  ],
})
export class TextEditorModule { }
